import { render, staticRenderFns } from "./CounselorSearch.vue?vue&type=template&id=278987e4&scoped=true&"
import script from "./CounselorSearch.vue?vue&type=script&lang=js&"
export * from "./CounselorSearch.vue?vue&type=script&lang=js&"
import style0 from "./CounselorSearch.vue?vue&type=style&index=0&id=278987e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278987e4",
  null
  
)

export default component.exports